/*
 * @providesModule RandomizeAvatarUtil
 *
 */

const cdn_url = 'https://cdn.skillz.com/';
const cdn_path_prefix = 'default-profile-pics/';
const cdn_path_suffix = '.png';
const default_profile_pictures = ['Guy1', 'Guy2', 'Girl1', 'Girl2', 'Girl3'];

const default_profile_backgrounds = [
  '001',
  '002',
  '003',
  '004',
  '005',
  '006',
  '007',
  '008',
  '009',
  '010',
];

const _getRandomDefaultAvatarURL = () => {
  const randomImage =
    default_profile_pictures[Math.floor(Math.random() * default_profile_pictures.length)] +
    '_' +
    default_profile_backgrounds[Math.floor(Math.random() * default_profile_backgrounds.length)] +
    cdn_path_suffix;

  const newURL = cdn_url + cdn_path_prefix + randomImage;
  return {
    url: newURL,
    imageName: randomImage,
  };
};

export const getRandomAvatar = (): Promise<string> => {
  return new Promise((resolve: (filePath: string) => void) => {
    const imageInfo = _getRandomDefaultAvatarURL();

    // TODO (websdk-ms-2-phase-account-management): Check if the images render correctly
    console.log('WebSDK: RandomizeAvatarUtil.getRandomAvatar() MOCK USED');

    resolve(imageInfo.url);
  });
};
